import { z } from 'zod';
import { USER_ROLES } from '../enums.js';
import { localeSchema } from './common.js';
/**
 * Вход в Mini App. На сервер уходит подписанная строка `initData` целиком —
 * сервер проверяет подпись сам. `initDataUnsafe` не принимается никогда:
 * это неподписанные данные, подделываемые в консоли браузера.
 */
export const telegramAuthBody = z.object({
    initData: z.string().min(1),
});
export const adminLoginBody = z.object({
    login: z.string().min(1).max(64),
    password: z.string().min(1).max(200),
});
export const currentUser = z.object({
    id: z.number().int().positive(),
    role: z.enum(USER_ROLES),
    first_name: z.string().nullable(),
    last_name: z.string().nullable(),
    phone: z.string().nullable(),
    locale: localeSchema,
    has_phone: z.boolean(),
    /**
     * Привязан ли Telegram. Сам идентификатор наружу не отдаём — для интерфейса
     * важен только факт: без привязки администратору не приходят уведомления.
     */
    has_telegram: z.boolean(),
    is_blocked: z.boolean(),
    /**
     * Точка сборки курьера. У клиента и администратора всегда `null`: поле
     * принадлежит роли курьера, и записать его может только он
     * (проверка — в `PATCH /api/profile`).
     *
     * Отдавать эти поля обязательно: без них курьер сохраняет точку сборки и
     * не может прочитать, что именно сохранилось.
     */
    pickup_lat: z.number().nullable(),
    pickup_lon: z.number().nullable(),
    pickup_address_text: z.string().nullable(),
});
export const authResponse = z.object({
    user: currentUser,
});
//# sourceMappingURL=auth.js.map